module.exports = __webpack_public_path__ + "img/boardwalk.6bf7ec2f.png";